import React from "react";
import { useNavigate } from "react-router";
import SearchTableButton from "../forms/buttons/SearchTableButton";
import WorkTypeLabel from "./WorkTypeLabel";
import { dateService } from "../../services/DateService";

/**
 * 差立作業一覧テーブル行コンポーネント
 * @param {number} workId 作業ID
 * @param {string} planStartedAt 計画開始日時
 * @param {string} workType 作業種別
 * @param {string} workplace 職場
 * @param {string} modelType 機種
 * @param {string} modelNumber 機種
 * @param {string} workProcess 作業工程
 * @class DispatchWorkTableRow
 */
export default function DispatchWorkTableRow({
  workId,
  planStartedAt,
  workType,
  workplace,
  modelType,
  modelNumber,
  workProcess,
}) {
  const navigate = useNavigate();
  const onClick = () => {
    if (window.innerWidth <= 820) {
      navigate(`/work-contents/edit/${workId}`);
    }
  };
  const splitDate = dateService
    .formatDBDatetime(planStartedAt, "yyyy/MM/dd HH:mm")
    .split(" ");
  return (
    <tr onClick={onClick}>
      <td className="col-date" data-label="開始日時">
        <span className="date-stack">
          <span className="date">{splitDate?.[0]}</span>
          <span className="time">{splitDate?.[1]}</span>
        </span>
      </td>
      <td className="col-type" data-label="作業種別">
        <WorkTypeLabel value={workType} />
      </td>
      <td data-label="職場">{workplace}</td>
      <td data-label="機種">{modelType}</td>
      <td data-label="工程">{workProcess}</td>
      <td data-label="機番">{modelNumber}</td>
      <td className="col-action">
        <SearchTableButton path={`/work-contents/edit/${workId}`} />
      </td>
      <td className="row-hint">カード全体をタップして詳細へ進みます</td>
    </tr>
  );
}
